import React, { useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import XMarkSvg from "../../public/assets/images/x-mark.svg";
const HSAGide = () =>
  // { open, setOpen  }
  {
    const [open, setOpen] = useState(false);
    return (
      <div className="flex mt-3 relative">
        <div className="flex justify-between w-full">
          <div className="text-lg md:text-2xl text-white roboto-regular my-auto">
            Use your HSA/FSA account{" "}
            <button
              onClick={() => setOpen(true)}
              className="text-[#00adef] ml-2 hover:text-[#008bb9] underline  transition-colors duration-200 bg-transparent p-0 m-0 border-none text-lg md:text-2xl roboto-regular"
              data-mdb-ripple="true"
              data-mdb-ripple-color="light"
            >
              Learn more
            </button>
          </div>
          <img
            alt=""
            src={`./assets/images/hsa-logo.png`}
            className="w-[90px] h-[45px] mr-[6px]  rounded-full"
          />
        </div>

        <Transition appear show={open} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50"
            onClose={() => setOpen(false)}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black/25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-xl max-h-[500px] transform rounded-2xl bg-[#f5f5f5] text-left align-middle shadow-xl transition-all relative flex flex-col">
                    <div className="sticky top-0 z-10 bg-[#f5f5f5] px-10 pt-10 pb-4">
                      <button
                        onClick={() => setOpen(false)}
                        className="absolute top-3 right-[1.15rem] text-gray-800"
                        aria-label="Close"
                      >
                        <img
                          src={XMarkSvg}
                          alt="X Icon"
                          width="24"
                          height="24"
                        />
                      </button>
                      <h3 className="text-lg md:text-xl mb-3 text-center text-black roboto-bold my-auto">
                        Use your HSA/FSA Funds
                      </h3>
                    </div>
                    <div className="overflow-y-auto px-10 pb-10">
                      <div className="">
                        <h3 className="text-md md:text-md mb-1 uppercase text-[#00adef] roboto-bold">
                          Step 1
                        </h3>
                        <p className="text-md md:text-md text-black roboto-bold">
                          Checkout with your normal payment method. A credit
                          card
                          <span className="roboto-regular ml-1">
                            (not your HSA/FSA card)
                          </span>
                          or PayPal
                        </p>
                        <img
                          alt=""
                          src={`./assets/images/hsa1.png`}
                          className="w-full h-full mt-2 p-6 rounded-[2rem]"
                        />
                      </div>
                      <div className="mt-4">
                        <h3 className="text-md md:text-md mb-1 uppercase text-[#00adef] roboto-bold">
                          Step 2
                        </h3>
                        <p className="text-md md:text-md text-black roboto-bold">
                          Obtain a letter of medical necessity from your Doctor
                        </p>
                        <a
                          href="/assets/images/HSA.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-[#00adef] text-md md:text-md mt-[0.15rem] d-block roboto-bold hover:text-[#008bb9] underline transition-colors duration-200"
                        >
                          See example letter
                        </a>
                        <img
                          alt=""
                          src={`./assets/images/hsa2.png`}
                          className="w-full h-full p-6 mt-2 rounded-[2rem]"
                        />
                      </div>
                      <div className="mt-4">
                        <h3 className="text-md md:text-md mb-1 uppercase text-[#00adef] roboto-bold">
                          Step 3
                        </h3>
                        <p className="text-md md:text-md text-black roboto-bold">
                          Maintain your letter in your records or submit to your
                          HSA/FSA administrator.
                          <span className="roboto-regular ml-1">
                            Contact your HSA/FSA if you have any questions
                          </span>
                        </p>
                      </div>

                      <div className="mt-6">
                        <h3 className="text-md md:text-md mb-1 uppercase text-[#00adef] roboto-bold">
                          Step 4
                        </h3>
                        <p className="text-md md:text-md text-black roboto-bold">
                          Reimburse yourself from your HSA/FSA account
                        </p>

                        <img
                          alt=""
                          src={`./assets/images/hsa3.png`}
                          className="w-full h-full p-6 mt-2 rounded-[2rem]"
                        />
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </div>
    );
  };

export default HSAGide;
